import { Modal, ModalityCodesEnum, SelectOptionType } from '@octano/global-ui';
import { useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'reactstrap';
import { PeriodType } from '../../../../../../../types/sectionMaintainerTypes';
import { ScheduleSectionForm } from '../../../../../../SectionsMaintainer/parts/ModalMaintainerSchedule';
import { ScheduleSectionFormData } from '../../../../../../SectionsMaintainer/parts/ModalMaintainerSchedulePre';
import MaintainerScheduleFormFields from './MaintainerScheduleFormFields';

type ModalMaintainerScheduleProps = {
  defaultValues?: ScheduleSectionForm;
  sectionId: number;
  sectionScheduleId?: number | null;
  closeModal: () => void;
  onSave: (
    values: ScheduleSectionFormData,
    index?: number,
  ) => void | Promise<void>;
  scheduleIndex?: number;
  period?: PeriodType;
  options: Record<
    | 'activityOptions'
    | 'campusOptions'
    | 'moduleStartOptions'
    | 'moduleEndOptions'
    | 'responsibleOptions'
    | 'modalityOptions'
    | 'periodicityOptions',
    SelectOptionType[]
  >;
};

const ModalMaintainerSchedule = ({
  defaultValues,
  sectionId,
  sectionScheduleId,
  closeModal,
  onSave,
  scheduleIndex,
  options,
  period,
}: ModalMaintainerScheduleProps) => {
  const prefix = 'sectionsMaintainer.update.modalClass';
  const { t } = useTranslation();
  const methods = useForm<ScheduleSectionForm>({
    defaultValues: defaultValues,
  });
  const { handleSubmit, setValue, watch } = methods;
  const action = scheduleIndex !== undefined ? 'Update' : 'Create';
  const modality = watch('modality');

  //En modalidad presencial se muestra la sede de la sección
  useEffect(() => {
    if (modality?.deliveryMode === ModalityCodesEnum.OL) {
      setValue('campus', defaultValues?.campus);
    }
  }, [modality, defaultValues, setValue]);

  const onSubmit = useCallback(
    (values: ScheduleSectionFormData) => {
      return onSave(values, scheduleIndex);
    },
    [onSave, scheduleIndex],
  );

  return (
    <Modal isOpen toggle={closeModal} size="xl">
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit as any)}>
          <p className="fs-22 text-dark text-center mb-4">
            {t(`${prefix}.title${action}`)}
          </p>
          <Row>
            <Col xs={12} lg={10} className="mx-auto text-center">
              <p className="fs-16 text-light mb-5">
                {t(`${prefix}.subtitle${action}`)}
              </p>
            </Col>
          </Row>
          <MaintainerScheduleFormFields
            action={action}
            sectionId={sectionId}
            sectionScheduleId={sectionScheduleId}
            activityOptions={options.activityOptions}
            campusOptions={options.campusOptions}
            moduleStartOptions={options.moduleStartOptions}
            moduleEndOptions={options.moduleEndOptions}
            responsibleOptions={options.responsibleOptions}
            modalityOptions={options.modalityOptions}
            periodicityOptions={options.periodicityOptions}
            onClose={closeModal}
            period={period}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
};

export default ModalMaintainerSchedule;
